import React from "react";
import { ISignupClient, TLookupInviteDto, SIGNUP_CLIENT } from "commons/clients";
import { useApplication } from "commons";
import { useLocation } from "react-router-dom";
import Nullable = Common.Nullable;
import { ISignupViewModel } from "features/signup";

export interface IUseSignupInvite {
  checkSignupInvite(): Promise<Nullable<TLookupInviteDto>>;
}

export function useSignupInvite(signupViewModel: ISignupViewModel) {
  const app = useApplication();
  const signupClient = app.getService<ISignupClient>(SIGNUP_CLIENT);
  const { search, hash } = useLocation();

  const queryParams = React.useMemo(() => {
    return search || hashToSearh(hash); // very specific case due to adb2c limitations
  }, [search, hash]);

  const checkSignupInvite = React.useCallback(async (): Promise<Nullable<TLookupInviteDto>> => {
    const inviteLookupDone = signupViewModel.getInviteLookupDone();

    if (queryParams && !inviteLookupDone) {
      try {
        return await signupClient.lookupInvite({
          queryString: queryParams
        });
      } catch (error) {
        return null;
      }
    }

    return null;
  }, [signupClient, queryParams, signupViewModel]);

  return { checkSignupInvite };
}

function hashToSearh(hash: string): string {
  return hash ? hash.replace("#", "?") : "";
}
